import React from "react";
import styled from "styled-components";

const Card = styled.div`
    background: ${(props) => (props.theme === "light" ? "white" : "#374151")};
    color: ${(props) => (props.theme === "light" ? "#111827" : "white")};
    border: 1px solid ${(props) => (props.theme === "light" ? "#e5e7eb" : "#4b5563")};
    border-radius: 0.75rem;
    overflow: hidden;
    transition: transform 0.2s, box-shadow 0.2s;
    display: flex;
    flex-direction: column;
    cursor: pointer;

    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
    }
`;

const CoverArea = styled.div`
    height: 220px; /* 높이를 조금 더 늘려서 시원하게 */
    background-color: ${(props) => (props.theme === "light" ? "#f3f4f6" : "#1f2937")};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 4rem;
    padding: 10px; /* 이미지 주변에 약간의 여백 */
`;

const InfoArea = styled.div`
    padding: 1.25rem;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`;

const Badge = styled.span`
    background-color: ${(props) => (props.theme === "light" ? "#eff6ff" : "#1e3a8a")};
    color: ${(props) => (props.theme === "light" ? "#2563eb" : "#93c5fd")};
    padding: 0.25rem 0.5rem;
    border-radius: 9999px;
    font-size: 0.75rem;
    font-weight: 600;
    width: fit-content;
    margin-bottom: 0.5rem;
`;

const Title = styled.h3`
    font-size: 1.125rem;
    font-weight: bold;
    margin: 0 0 0.25rem 0;
    line-height: 1.4;
`;

const Author = styled.p`
    font-size: 0.875rem;
    color: ${(props) => (props.theme === "light" ? "#6b7280" : "#9ca3af")};
    margin: 0 0 1rem 0;
`;

const Footer = styled.div`
    margin-top: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const Price = styled.span`
    font-size: 1.125rem;
    font-weight: 700;
`;

const AddButton = styled.button`
    background-color: #4f46e5;
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 0.5rem;
    font-size: 0.875rem;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background-color: #4338ca;
    }
`;

function BookCard({ book, theme, onAddToCart, onViewDetail, convertPrice }) {
    return (
        <Card theme={theme} onClick={() => onViewDetail(book)}>
            <CoverArea theme={theme}>
                {book.cover.startsWith("http") ? (
                    <img
                        src={book.cover}
                        alt={book.title}
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain", /* ★ 여기가 수정됨: cover -> contain */
                            borderRadius: "4px"
                        }}
                    />
                ) : (
                    book.cover // 이모지인 경우
                )}
            </CoverArea>
            <InfoArea>
                <Badge theme={theme}>{book.category || "IT/개발"}</Badge>
                <Title>{book.title}</Title>
                <Author theme={theme}>{book.author}</Author>

                <Footer>
                    <Price>{convertPrice(book.price)}</Price>
                    <AddButton
                        onClick={(e) => {
                            e.stopPropagation();
                            onAddToCart(book);
                        }}
                    >
                        담기
                    </AddButton>
                </Footer>
            </InfoArea>
        </Card>
    );
}

export default BookCard;